import { Elements } from 'prismic-reactjs';
import React from 'react';
import { Link } from 'react-router-dom';
import { linkResolver } from '../prismic';

const propsWithUniqueKey = (props: object, key: any) => {
  return Object.assign(props || {}, { key });
};

export const questionHtmlSerializer = (
  type: any,
  element: any,
  content: any,
  children: any,
  key: any
) => {
  switch (type) {
    case Elements.preformatted:
      return <div dangerouslySetInnerHTML={{ __html: element.text }} key={key} />;

    case Elements.hyperlink: {
      if (
        element.data.link_type === 'Web' &&
        element.data.url.indexOf('www.omniafishing.com') > -1
      ) {
        const localUrl = element.data.url.split('www.omniafishing.com')[1];
        return (
          <Link key={localUrl} to={localUrl}>
            {content}
          </Link>
        );
      }
    }

    // Return null to stick with the default behavior
    default:
      return null;
  }
};

export const serializeHyperlink = (
  type: any,
  element: any,
  content: any,
  children: any,
  index: any
) => {
  if (element.data.link_type === 'Web' && element.data.url.indexOf('www.omniafishing.com') > -1) {
    const localUrl = element.data.url.split('www.omniafishing.com')[1];
    return (
      <Link key={`${localUrl}:${index}`} to={localUrl}>
        {content}
      </Link>
    );
  }
  return null;
};

export const articleHtmlSerializer = (
  type: any,
  element: any,
  content: any,
  children: any,
  key: any
) => {
  switch (type) {
    case Elements.hyperlink: {
      const targetAttr = element.data.target
        ? {
            target: element.data.target,
          }
        : {};
      const relAttr = element.data.target
        ? {
            rel: 'noopener',
          }
        : {};
      const href = element.data.url || linkResolver(element.data);
      const props = Object.assign(
        {
          href,
        },
        targetAttr,
        relAttr
      );
      return <a {...propsWithUniqueKey(props, key)}>{children}</a>;
    }

    // Return null to stick with the default behavior
    default:
      return null;
  }
};
